import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { Helmet } from 'react-helmet';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { forgotPassword } from '../../services/services';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await forgotPassword({ email });
      message.success('Password reset email sent. Please check your inbox.');
      setSuccess(true);
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Failed to send reset email. Please try again.';
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Forgot Password - Startup Business Partners</title>
      </Helmet>
      <Navbar />
      <br />
      <br />
      <div className="forgot-password-form d-flex align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
              <div className="form-wrapper">
                <div className="card card-shadow">
                  <div className="card-header">
                    <br />
                    <h4 className="text-center">Forgot Password</h4>
                  </div>
                  <div className="card-body">
                    {success ? (
                      <div className="alert alert-success">
                        <p>We've sent an email to {email} with instructions to reset your password.</p>
                        <p>Didn't receive the email? Check your spam folder or <a href="/forgot-password" onClick={(e) => { e.preventDefault(); setSuccess(false); }}>try again</a>.</p>
                      </div>
                    ) : (
                      <>
                        <p>Enter your email address and we'll send you a link to reset your password.</p>
                        <form onSubmit={handleSubmit}>
                          <div className="form-group">
                            <input
                              type="email"
                              placeholder="Email Address"
                              className="form-control"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                          </div>
                          <div className="form-group text-center m-bottom-20">
                            <button
                              className="btn btn-secondary"
                              type="submit"
                              disabled={loading}
                            >
                              {loading ? 'Sending...' : 'Send Reset Link'}
                            </button>
                          </div>
                        </form>
                      </>
                    )}
                    <p className="text-center m-bottom-25">
                      Remember your password? <a href="/login">Sign In</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ForgotPassword;